export default function productsAdditionalInfo(state = {}, action) {
  if (action.type === 'SET_ADDITIONAL_INFO') {
    if (Array.isArray(state.metaElementData) && state.metaElementData.length > 0) {
      action.values.metaElementData = state.metaElementData;
    }
    const { values = {} } = action;
    return { ...state, ...values };
  }
  return state;
}
